import React, { useState, useEffect, useRef } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';

import {
    DivMenuPrinc,
    BgMenuPrinc,
    BtMenuPesquisas,
    BtMenuNoticias,
    BtMenuRelatorio,
    BtMenuConteudos,
    BtMenuRegras,
  } from '../Estilos'

import ImgBtMenuPesquisas from "../Images/BtMenuPesquisas.png";
import ImgBtMenuPesquisasAtivo from "../Images/BtMenuPesquisas_Ativo.png";

import ImgBtMenuNoticias from "../Images/BtMenuNoticia.png";
import ImgBtMenuNoticiasAtivo from "../Images/BtMenuNoticia_Ativo.png";

import ImgBtMenuRelatorio from "../Images/BtMenuRelatorio.png";
import ImgBtMenuRelatorioAtivo from "../Images/BtMenuRelatorio_Ativo.png";

import ImgBtMenuConteudos from "../Images/BtMenuConteudos.png";
import ImgBtMenuConteudosAtivo from "../Images/BtMenuConteudos_Ativo.png";

import ImgBtMenuRegras from "../Images/BtMenuRegras.png";
import ImgBtMenuRegrasAtivo from "../Images/BtMenuRegras_Ativo.png";

function MenuPrinc(props) {

  const history = useHistory();

  return (
      <>
        <DivMenuPrinc>            

            {props.Pagina !== "Pesquisas" ? 
                <BtMenuPesquisas onClick={ ()=> history.push({ pathname: '/home', state: {} }) } Bg={ImgBtMenuPesquisas} BgAtivo={ImgBtMenuPesquisasAtivo} />
            :
                <BtMenuPesquisas onClick={ ()=> history.push({ pathname: '/home', state: {} }) } Bg={ImgBtMenuPesquisasAtivo} BgAtivo={ImgBtMenuPesquisasAtivo} />
            }

            {props.Pagina !== "Noticias" ? 
                <BtMenuNoticias onClick={ ()=> history.push({ pathname: '/noticias', state: {} }) } Bg={ImgBtMenuNoticias} BgAtivo={ImgBtMenuNoticiasAtivo} />
            :
                <BtMenuNoticias onClick={ ()=> history.push({ pathname: '/noticias', state: {} }) } Bg={ImgBtMenuNoticiasAtivo} BgAtivo={ImgBtMenuNoticiasAtivo} />
            }

            {
            localStorage.getItem("c_cargo") !== '2653' && localStorage.getItem("c_cargo") !== '2661' ?
            props.Pagina !== "Relatorios" ? 
                <BtMenuRelatorio onClick={ ()=> history.push({ pathname: '/relatorios', state: {} }) } Bg={ImgBtMenuRelatorio} BgAtivo={ImgBtMenuRelatorioAtivo} />
            :
                <BtMenuRelatorio onClick={ ()=> history.push({ pathname: '/relatorios', state: {} }) } Bg={ImgBtMenuRelatorioAtivo} BgAtivo={ImgBtMenuRelatorioAtivo} />
            : null }

            {props.Pagina !== "Conteudos" ? 
                <BtMenuConteudos onClick={ ()=> history.push({ pathname: '/conteudos', state: {} }) } Bg={ImgBtMenuConteudos} BgAtivo={ImgBtMenuConteudosAtivo} />
            :
                <BtMenuConteudos onClick={ ()=> history.push({ pathname: '/conteudos', state: {} }) } Bg={ImgBtMenuConteudosAtivo} BgAtivo={ImgBtMenuConteudosAtivo} />
            }

            {props.Pagina !== "Regras" ? 
                <BtMenuRegras onClick={ ()=> history.push({ pathname: '/regras', state: {} }) } Bg={ImgBtMenuRegras} BgAtivo={ImgBtMenuRegrasAtivo} />
            :
                <BtMenuRegras onClick={ ()=> history.push({ pathname: '/regras', state: {} }) } Bg={ImgBtMenuRegrasAtivo} BgAtivo={ImgBtMenuRegrasAtivo} />
            }

            <BgMenuPrinc />
        </DivMenuPrinc>

      </>
  );
  
}

export default MenuPrinc;